/* @flow */
import cx from 'classnames';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Coin from 'components/Coin.jsx';
import Avatar from 'components/Avatar.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import NameAndSignatureQuery from 'components/NameAndSignatureQuery.jsx';
import PotentialChatMember from 'entities/PotentialChatMember';
import Spacing from 'styles/Spacing.css';
import Text from 'components/Text.jsx';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

import styles from './styles/MessageStarterItem.css';

class MessageStarterItem extends React.Component {
  props: {
    member: PotentialChatMember,
    selectable: boolean,
    selected: boolean,
    query: string,
    className: ?string,
  };

  static defaultProps = {
    selectable: false,
    selected: false,
  };

  shouldComponentUpdate(nextProps: Object) {
    // HACK assumes `member` doesn't mutate during the life of this component
    return shallowCompare(this, nextProps, null);
  }

  renderReachability() {
    const { member } = this.props;
    const user = member.getUser();

    if (user.getReachabilityState() !== 'active') {
      return null;
    }

    const reachability = user.getReachability();

    return (
      <Text className={styles.reachability} size="xsmall">
        {reachability['medium']}
      </Text>
    );
  }

  renderDroplet() {
    if (this.props.selectable) {
      if (this.props.selected) {
        return (
          <Coin
            className={Spacing.marginRightLarge}
            color="brand"
            size="xxxlarge">
            <Glyph name="check" color="white" size="large" solo />
          </Coin>
        );
      } else {
        return (
          <Coin
            className={Spacing.marginRightLarge}
            border="koala"
            size="xxxlarge"
          />
        );
      }
    }

    const { member } = this.props;
    const user = member.getUser();

    return (
      <Avatar
        className={Spacing.marginRightLarge}
        text={user.getInitials()}
        colorHex={user.getColor()}
        size="medium"
      />
    );
  }

  render() {
    const { member, query } = this.props;
    const parser = TextEntities.createTextMatchingParser(query);

    return (
      <a
        className={cx(styles.this, this.props.className)}>
        <FlexibleBlock flex="left">
          <FlexibleBlock flex="right">
            {this.renderDroplet()}
            <div>
              <NameAndSignatureQuery
                displayName={member.getName()}
                fullName={member.getUser().getFullName()}
                query={query}
              />
              <Text color="koala" size="xsmall" truncate>
                <TextWithEntities
                  text={member.getConnectionDescription()}
                  entities={parser(member.getConnectionDescription())}
                />
              </Text>
            </div>
          </FlexibleBlock>
          {this.renderReachability()}
        </FlexibleBlock>
      </a>
    );
  }
}

export default MessageStarterItem;



// WEBPACK FOOTER //
// ./src/chat/components/MessageStarterItem.jsx